import {connect} from 'react-redux';
import {Field, FieldArray, formValueSelector, reduxForm} from 'redux-form';
import {ActionsRow, ff, field, form, Icon} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
const {Form, FormActions, FormBody} = form;
import {Button, ButtonToolbar, Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faArrowsAltV} from '@fortawesome/free-solid-svg-icons';
import TablePanel from "../components/TablePanel";
import ListBox from "../components/ListBox";
import {fixOrder, changePosition} from "../utils/utils";
import CustomCheckboxField from "../components/CustomCheckboxField";
import {withTranslation, WithTranslation} from "react-i18next";

// Trik jelikož <option> neumí mít boolean hodnoty, které potřebujeme do VO
const NULL = "null";
const TRUE = "true";
const FALSE = "false";

/**
 * Formulář pro tvorbu/úpravu úkonů a jejich položek.
 */
class UkonForm extends Component<WithTranslation> {

    static formName = 'UkonForm';

    renderIntField = ({input, placeholder}) => (
        <field.Number int {...input} placeholder={placeholder} />
    );

    renderStringField = ({input, placeholder}) => (
        <field.String {...input} placeholder={placeholder} />
    );

    renderSelectField = ({input, placeholder}) => (
        <field.Select {...input}>
            <option value={NULL} disabled>{placeholder}</option>
            <option value={TRUE}>Aktivní</option>
            <option value={FALSE}>Neaktivní</option>
        </field.Select>
    );

    updatePolozky = (polozky) => {
        this.props.change('polozky', polozky);
    };

    handlePolozkaOrderChanged = (index1, index2) => {
        const newPolozky = [...this.props.polozky];
        changePosition(newPolozky, index1, index2);
        fixOrder(newPolozky, "poradi", Math.min(index1, index2));
        this.updatePolozky(newPolozky);
    };

    handleRemovePolozka = (index) => {
        const newPolozky = [...this.props.polozky];
        newPolozky.splice(index, 1);
        fixOrder(newPolozky, "poradi", index);
        this.updatePolozky(newPolozky);
    };

    renderPolozky = ({fields}) => {
        const {t} = this.props;
        return <Card>
            <CardHeader>
                <ActionsRow actions={
                    <ButtonToolbar>
                        <Button type="button" onClick={() => fields.push({poradi: fields.length + 1})}>{t('new_f')}</Button>
                    </ButtonToolbar>
                }>
                    Položky
                </ActionsRow>
            </CardHeader>
            <CardBody>
                {fields.length > 0 ?
                <TablePanel bordered>
                    <ListBox
                        items={fields.getAll() || []}
                        sortable
                        onChangeOrder={this.handlePolozkaOrderChanged}
                        renderItemContent={i => <CardBody key={i.index}>
                            <ActionsRow actions={
                                <Button onClick={this.handleRemovePolozka.bind(this, i.index)} color="action action-hover">
                                    <Icon icon="trash-o"/>
                                </Button>
                            }>
                                <Row>
                                    <Col xs={1} className="icon-hover">
                                        <FontAwesomeIcon icon={faArrowsAltV} size="lg" />
                                    </Col>
                                    <Col xs={2}>
                                        <Field
                                            name={`polozky[${i.index}].kodUkon`}
                                            component={this.renderStringField}
                                            placeholder={"Kód"}
                                        />
                                    </Col>
                                    <Col xs={4}>
                                        <Field
                                            name={`polozky[${i.index}].popisUkon`}
                                            component={this.renderStringField}
                                            placeholder={"Popis"}
                                        />
                                    </Col>
                                    <Col xs={2}>
                                        <Field
                                            name={`polozky[${i.index}].napoveda`}
                                            component={this.renderStringField}
                                            placeholder={"Nápověda"}
                                        />
                                    </Col>
                                    <Col xs={3}>
                                        <Field
                                            name={`polozky[${i.index}].neaktivni`}
                                            component={this.renderSelectField}
                                            placeholder={t('active')}
                                            format={value => value === true ? FALSE : value === false ? TRUE : NULL}
                                            normalize={value => value === NULL ? null : value !== TRUE}
                                        />
                                    </Col>
                                </Row>
                            </ActionsRow>
                        </CardBody>}
                    />
                </TablePanel>  : <i>{t('no_items')}</i>}
            </CardBody>
        </Card>
    };

    render() {
        const {onClose, submitting, handleSubmit, t} = this.props;
        return <Form onSubmit={handleSubmit} horizontal>
            <FormBody>
                <Row>
                    <Col xs={4}>
                        <Card>
                            <CardHeader>
                                Úkon
                            </CardHeader>
                            <CardBody>
                                {/*<ff.Number int label="Pořadí" name="poradi" disabled/>*/}
                                <ff.String label={t('labels.name')} name="nazevUkon" required disabled={submitting}/>
                                <CustomCheckboxField label={t('required')} name="povinne" disabled={submitting}/>
                                <CustomCheckboxField label={t('inactive')} name="neaktivni" disabled={submitting}/>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col xs={8}>
                        <FieldArray name="polozky" component={this.renderPolozky} />
                    </Col>
                </Row>
            </FormBody>
            <FormActions onClose={onClose} storeButton={t('save')} cancelButton={t('buttons.cancel')} disabled={submitting}/>
        </Form>
    }
}

const selector = formValueSelector(UkonForm.formName);

const mapStateToProps = state => ({
    polozky: selector(state, "polozky"),
});

export default withTranslation()(connect(mapStateToProps)(reduxForm({
    form: UkonForm.formName,
})(UkonForm)));
